// src/pages/secondLife/vorschauLage.js
//
// R16-N4 — der Ladezustand der Produktvorschau ist ABGELEITET, nicht gesetzt.
//
// 🔴 **Der Befund der Regel-16-Wiedervorlage (2026-11-03).** `vorschauLaedt`
// startete `false` und wurde erst im `useEffect` wahr — der laeuft NACH dem
// Paint. Beim ersten Anzeigen und bei JEDEM Wechsel stand damit fuer einen
// Frame der Vorschauinhalt des vorigen Falls (und ein Knopf, der gleich wieder
// verschwindet).
//
// Die Regel steht hier und nicht in der Komponente, damit sie ohne DOM pruefbar
// ist (Hausform `bestand.js`, `rabatt.js`): die Komponente rendert nur.
//
// Der Schluessel nennt den Fall UND alles, was die Vorschau neu lesen laesst
// (`sku|grade|zustand|kladdeId|entwurf|neuZaehler`). `fertigFuer` ist der
// Schluessel, dessen Antwort zuletzt ankam. Weichen sie ab, ist die Antwort
// unterwegs — dann gilt `laedt`, und die alten Daten werden NICHT gezeigt.

/**
 * @param {{schluessel: string|null, fertigFuer: string|null, vorschau: *, fehler: *}} lage
 * @returns {{laedt: boolean, vorschau: *, fehler: *}}
 */
export function vorschauLage({ schluessel, fertigFuer, vorschau, fehler }) {
  const laedt = schluessel != null && fertigFuer !== schluessel;
  return {
    laedt,
    vorschau: laedt ? null : vorschau,
    fehler: laedt ? null : fehler,
  };
}
